import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';
import { UiIcon } from 'ui-components';
import { getCurrentSlice } from 'utils';
import { toggleSidebarFilters } from 'store';
import { StyledAddFilterButton } from './AddFilterButton.styles';

let sliceModule = {};

function AddFilterButton({ allowedFilters }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const filters = useSelector(
    (state) => state[state.filterReducer.filtersContext]?.filters
  );

  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );

  const allFilters = Object.keys(filters || []).filter(
    (key) => !allowedFilters?.length || allowedFilters.includes(key)
  );
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

  useEffect(() => {
    if (reducerName) {
      sliceModule = getCurrentSlice(reducerName);
    }
  }, [reducerName]);

  const handleSelectFilter = (componentName) => {
    dispatch(
      sliceModule?.setSelectedFilter(isMobile ? undefined : componentName)
    );
  };

  const openDialog = () => {
    dispatch(toggleSidebarFilters(true));
    handleSelectFilter(allFilters[0]);
  };

  return (
    <>
      <StyledAddFilterButton
        onClick={openDialog}
        variant='contained'
        startIcon={<UiIcon icon='ri-filter-line' color='#FFFFFF' />}
        data-testid='add-filter-btn'
      >
        {t('filter:addFilter')}
      </StyledAddFilterButton>
    </>
  );
}

AddFilterButton.propTypes = {
  allowedFilters: PropTypes.arrayOf(PropTypes.string),
};

export default AddFilterButton;
